export default __webpack_public_path__ + "static/media/warehouse_service.f074031f.png";